import CardUpArrow from "./UpArrow";
export default CardUpArrow;